import { render, staticRenderFns } from "./SearchAds.vue?vue&type=template&id=6c3e825e&scoped=true"
import script from "./SearchAds.vue?vue&type=script&lang=js"
export * from "./SearchAds.vue?vue&type=script&lang=js"
import style0 from "./SearchAds.vue?vue&type=style&index=0&id=6c3e825e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e825e",
  null
  
)

export default component.exports